module.exports = "/fonts/opensanslightitalic.ttf";